import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyC_rHZZ_PD6g_HVeapbxUNDsw6oJ-Yd3bQ",
  authDomain: "howareyou-ba383.firebaseapp.com",
  projectId: "howareyou-ba383",
  storageBucket: "howareyou-ba383.firebasestorage.app",
  messagingSenderId: "841034342156",
  appId: "1:841034342156:web:a6306a0dda5ab89123f329",
  measurementId: "G-0XTYD1V0PC",
};
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
